import React, { useState } from 'react';
import SearchControl from '../SearchControl';
import SoundManager from '../../services/SoundManager';
import FixedBottomNavbar from '../FixedBottomNavbar';
import RangeControl from '../NavbarControl/RangeControl';
import { Button, Form } from 'react-bootstrap';
import SequencerWorkspace from '../SoundSequencer';

export default function App() {
  const [volume, setVolume] = useState(1);
  const [pitch, setPitch] = useState(1);
  const [search, setSearch] = useState('');
  const [replay, setReplay] = useState(true);

  const setVolumeFn = (n: number) => {
    SoundManager.setVolume(n);
    setVolume(n);
  }
  const setPitchFn = (n: number) => {
    SoundManager.setPitch(n, replay);
    setPitch(n);
  }

  return <>
    <FixedBottomNavbar>
      <RangeControl name="Volume" value={volume} min={0} max={1} setValue={setVolumeFn}/>
      <RangeControl name="Pitch" value={pitch} min={0.5} max={2} setValue={setPitchFn}/>
      <>
        <Form.Check
          className="navbar-inside-center"
          label="Replay on pitch change" defaultChecked={replay}
          onClick={() => setReplay(!replay)}/>
        <Button
          className="navbar-inside-center" size="sm" variant="danger"
          onClick={() => SoundManager.stopAll()}
        ><i className={'bi-stop'}/> Stop all</Button>
      </>
    </FixedBottomNavbar>
    <div className="container my-4 pb-5">
      <h2 className="text-center">Minecraft Sound Modulator</h2>
      <SearchControl value={search} setValue={setSearch}/>
      <SequencerWorkspace search={search}/>
    </div>
  </>;
}
